// 📄 VoiceDatabaseCitation.jsx

import { useTranslation } from 'react-i18next';
import CitationLabel from './CitationLabel';

const VoiceDatabaseCitation = ({
  database,
  labelT = null,
  showCollectionChangesNote = false,
  children = null,
}) => {
  const { t } = useTranslation();
  const citationT = labelT || t;

  if (!database) return null;

  const citations = Array.isArray(database.citations) ? database.citations : [];
  const licenses = Array.isArray(database.licenses) ? database.licenses : [];

  return (
    <div>
      <CitationLabel>{citationT('database')}</CitationLabel>
      <div>
        {citations.map((citation, index) => (
          <span key={`${citation.citationLink || citation.citationText || 'citation'}-${index}`}>
            {index > 0 && <br />}
            {citation.citationText}
            {citation.citationLink && (
              <>
                {' '}
                <a
                  href={citation.citationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {citation.citationLink}
                </a>
              </>
            )}
          </span>
        ))}

        {licenses.map((license, index) => (
          <span key={`${license.licenseLink || license.licenseText || 'license'}-${index}`}>
            {citations.length > 0 || index > 0 ? '. ' : ''}
            {license.licenseLink
              ? citationT('creative_commons_license_notice')
              : license.licenseText}
            {license.licenseLink && (
              <>
                {' '}
                <a
                  href={license.licenseLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {license.licenseLink}
                </a>
              </>
            )}
          </span>
        ))}

        {showCollectionChangesNote && (
          <>
            <br />
            <em>{citationT('changes_made')}: {citationT('see_collection_below')}</em>
          </>
        )}
        {children}
        <br /><br />
      </div>
    </div>
  );
};

export default VoiceDatabaseCitation;
